var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlockageIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 62,
    viewBox: "0 0 105 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.0056 31.0013C71.0056 39.5006 64.1471 46.3858 55.6928 46.3858C47.2385 46.3858 40.38 39.5006 40.38 31.0013C40.38 22.5019 47.2385 15.6168 55.6928 15.6168C64.1471 15.6168 71.0056 22.5019 71.0056 31.0013Z",
    stroke: "#0071C2",
    strokeWidth: 1.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.53022,
    d: "M76.8316 30.9964C76.8316 42.7266 67.3655 52.232 55.6932 52.232C44.0208 52.232 34.5547 42.7266 34.5547 30.9964C34.5547 19.2661 44.0208 9.76074 55.6932 9.76074C67.3655 9.76074 76.8316 19.2661 76.8316 30.9964Z",
    stroke: "#0071C2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.382791,
    d: "M81.0888 31.0008C81.0888 45.0925 69.7168 56.5122 55.6936 56.5122C41.6703 56.5122 30.2983 45.0925 30.2983 31.0008C30.2983 16.909 41.6703 5.48926 55.6936 5.48926C69.7168 5.48926 81.0888 16.909 81.0888 31.0008Z",
    stroke: "#0071C2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.7905 31.7123L8.39233e-05 31.7123L51.7905 31.7123Z",
    fill: "#0071C2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7905 31.7123L8.51154e-05 31.7123",
    stroke: "#0071C2",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105 31.3569L58.1763 31.3569L105 31.3569Z",
    fill: "#0071C2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M105 31.3569L58.1762 31.3569",
    stroke: "#0071C2",
    strokeWidth: 1.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.382791,
    d: "M86.0539 31C86.0539 47.8468 72.4585 61.5 55.6925 61.5C38.9264 61.5 25.3311 47.8468 25.3311 31C25.3311 14.1532 38.9264 0.5 55.6925 0.5C72.4585 0.5 86.0539 14.1532 86.0539 31Z",
    stroke: "#0071C2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.7141 28.1522L60.3898 33.8534L54.7141 28.1522Z",
    fill: "#0071C2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7141 28.1522L60.3898 33.8534",
    stroke: "#0071C2",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.3787 28.1522L54.0543 33.8534L48.3787 28.1522Z",
    fill: "#0071C2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3787 28.1522L54.0543 33.8534",
    stroke: "#0071C2",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockageIcon);
export default __webpack_public_path__ + "static/media/blockageIcon.a2b00a41499bc6cbf63110d69e6af518.svg";
export { ForwardRef as ReactComponent };